/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `ALL` - 全て
* `DISABLED` - 無効
* `IMPORT` - 輸入
* `EXPORT` - 輸出
 */
export type ContainerTrackingTypeEnum = typeof ContainerTrackingTypeEnum[keyof typeof ContainerTrackingTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContainerTrackingTypeEnum = {
  ALL: 'ALL',
  DISABLED: 'DISABLED',
  IMPORT: 'IMPORT',
  EXPORT: 'EXPORT',
} as const;
